import { createSuccessToast, createToast } from '../../../redux/modules/app';
import { globalRequirementTemplateBuilder } from '../../../redux/reducer';

const editTemplate = async ({ e, dispatch, history, id, companyId }) => {
  e?.preventDefault();
  e?.stopPropagation();

  dispatch(createToast({ title: 'Fetching template details', duration: 60000 }));

  const templateId = id ?? Number(e.target.value);
  const currentCompanyId = companyId ?? Number(e.target.getAttribute('data-company-id'));
  await dispatch(globalRequirementTemplateBuilder.getRequirementTemplate(templateId));

  dispatch(createSuccessToast({ title: 'Success!', duration: 2000 }));

  history.replace(
    `/companies/${currentCompanyId}/create-templates/requirement-templates/${templateId}`
  );
};

export default editTemplate;
